import './App.scss';
import {
  FluentProvider,
  webLightTheme  
} from '@fluentui/react-components';
import { BrowserRouter } from "react-router-dom";
import AppRoute from "./app-route/AppRoute"
import Footer from './components/footer/Footer';
import { useAuth } from "./auth/AuthProvider";
import Header from './components/header/Header';

function App() {
  const {isAuthenticated, user, logout} = useAuth();
  return (
    <FluentProvider theme={webLightTheme}>
      <BrowserRouter>
      <div className="app-grid-layout">        
        <div className='app-header'>
          <Header/>
        </div>
        <div className='global-message'>                                  
        </div>
        <div className='app-content'>
          <AppRoute></AppRoute>
        </div>
        <div className='footer'>
          <Footer />
        </div>
      </div>
      </BrowserRouter>
    </FluentProvider>    
  );
}

export default App;